import { create } from "zustand";
import { ITag } from "../services/types";

interface ITrendingTagsState {
  trendingTags: ITag[];
  setTrendingTags: (tags: ITag[]) => void;
}

export const useTrendingTagsStore = create<ITrendingTagsState>(
  (set) => ({
    trendingTags: [],
    setTrendingTags: (trendingTags: ITag[]) => {
      set(() => ({
        trendingTags,
      }));
    },
  }),
);
